"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplicaAdReportSummaryQuerySchema = exports.ReplicaAdReportGroupingQuerySchema = exports.ListReplicaAdReportsResponseSchema = exports.ListReplicaAdReportsQuerySchema = exports.UpdateReplicaAdReportsBodySchema = exports.UpdateReplicaAdReportSchema = exports.ReplicaAdReportSchema = exports.CreativeTypeQueryTypeSchema = exports.CreativeTypeQueryType = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const common_1 = require("./common");
const reports_1 = require("./reports");
// This aligns to the values we see in adReport.metadata.creativetype
// we use it to filter to one or the other type
// but we are only interested in these two flavours
var CreativeTypeQueryType;
(function (CreativeTypeQueryType) {
    CreativeTypeQueryType["CUSTOM_PRODUCT_PAGE"] = "CUSTOM_PRODUCT_PAGE";
    CreativeTypeQueryType["DEFAULT_PRODUCT_PAGE"] = "DEFAULT_PRODUCT_PAGE";
})(CreativeTypeQueryType = exports.CreativeTypeQueryType || (exports.CreativeTypeQueryType = {}));
exports.CreativeTypeQueryTypeSchema = (0, core_1.StringUnion)([
    CreativeTypeQueryType.CUSTOM_PRODUCT_PAGE,
    CreativeTypeQueryType.DEFAULT_PRODUCT_PAGE,
]);
exports.ReplicaAdReportSchema = (0, core_1.StrictObject)({
    ...common_1.ReplicaReportMetadataFields,
    ...reports_1.ReplicaReportFields,
    adRef: ruby_1.AppleProxyRefSchema,
    adGroupRef: ruby_1.AppleProxyRefSchema,
    // Looks like you can aldo have creativeId and other info here if needed
    purpose: typebox_1.Type.Optional(ruby_1.PurposeSchema),
});
exports.UpdateReplicaAdReportSchema = typebox_1.Type.Object({
    ...reports_1.ReplicaReportFields,
    adRef: ruby_1.AppleProxyRefSchema,
    adGroupRef: ruby_1.AppleProxyRefSchema,
});
exports.UpdateReplicaAdReportsBodySchema = typebox_1.Type.Object({
    ...common_1.ReplicaReportMetadataFields,
    reports: typebox_1.Type.Array(exports.UpdateReplicaAdReportSchema),
});
exports.ListReplicaAdReportsQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    ...common_1.ReplicaReportMetadataQueryFields,
    adRef: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AppleProxyRefSchema)),
    purpose: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.PurposeSchema)),
    creativeType: typebox_1.Type.Optional(exports.CreativeTypeQueryTypeSchema),
});
exports.ListReplicaAdReportsResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.ReplicaAdReportSchema);
const GroupingBySchema = (0, core_1.StringUnion)([
    "campaignId",
    "period",
    "country",
    "campaignRef",
    "adGroupRef",
    "adRef",
    "purpose",
]);
exports.ReplicaAdReportGroupingQuerySchema = (0, core_1.StrictObject)({
    ...common_1.ReplicaReportMetadataQueryFields,
    by: GroupingBySchema,
    adRef: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AppleProxyRefSchema)),
    purpose: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.PurposeSchema)),
    creativeType: typebox_1.Type.Optional(exports.CreativeTypeQueryTypeSchema),
});
exports.ReplicaAdReportSummaryQuerySchema = (0, core_1.StrictObject)({
    ...common_1.ReplicaReportMetadataQueryFields,
    adRef: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AppleProxyRefSchema)),
    purpose: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.PurposeSchema)),
    creativeType: typebox_1.Type.Optional(exports.CreativeTypeQueryTypeSchema),
});
